"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react")); // eslint-disable-next-line react/prop-types


var IndicatorSeparator = function IndicatorSeparator(_ref) {
  var innerProps = _ref.innerProps,
      selectProps = _ref.selectProps;
  return _react["default"].createElement("span", (0, _extends2["default"])({
    className: selectProps.classes.indicatorSeparator
  }, innerProps));
};

var _default = IndicatorSeparator;
exports["default"] = _default;